const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./provider-fullcont-handler')
const {
	buildChatCardWarning,
	readFullcontField,
	friendlySectionName,
} = require('../../../../../components/chat/chat-card-warning')

export function start(detail) {
	if (obj[detail.act]) {
		obj[detail.act].start(detail)
	}
}

const obj = {
	load: { start: (detail) => { load(detail) } },
	submit: { start: (detail) => { submit(detail) } },
	typing: { start: (detail) => { typing(detail) } },
	beforeChat: { start: (detail) => { beforeChat(detail) } },
}

const PROVIDER_QUESTIONS = ['Outstanding debt to provider?', 'Recent orders?']

function getGeneralQuestions(type) {
	if (type === 'provider') {
		return PROVIDER_QUESTIONS
	}
}

function load(detail) {
	const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
	const recordId = fullcontActivo.getAttribute('data-dbid')

	const details = fullcontActivo
		? [
				{ label: 'Code', value: readFullcontField(fullcontActivo, 'provider_form_code') },
				{ label: 'Name', value: readFullcontField(fullcontActivo, 'provider_form_name') },
				{ label: 'Phone', value: readFullcontField(fullcontActivo, 'provider_form_phone') },
				{ label: 'Contact', value: readFullcontField(fullcontActivo, 'provider_form_contact') },
		  ]
		: []

	const cardWarning = buildChatCardWarning({
		entityDisplay: detail.dest,
		typeLabel: 'Provider (record)',
		recordId: recordId || '—',
		details,
		scopeNote: 'This chat is scoped to this provider and its saved IA history.',
	})

	if (recordId) {
		chat.start({
			dest: 'chat',
			act: 'quickview',
			actQuickview: 'show',
			type: 'provider',
			entity: 'provider',
			question: detail.question ?? '',
			generalQuestions: getGeneralQuestions('provider'),
			recordId: recordId,
			ev: detail.ev,
			cardWarning: cardWarning,
		})

		const msj = handler.getChatsFc()
		chat.start({
			dest: 'chat',
			act: 'load',
			chats: msj,
			generalQuestions: getGeneralQuestions('provider'),
			cardWarning: cardWarning,
		})
	}
}

function beforeChat(detail) {}

function submit(detail) {}

function typing(detail) {
	chatHandler.typing(detail)
}
